import { StoreState } from "..";

export const getFareOffersWithDetails = (state: StoreState) => state.brandedFares.fareOffersWithDetails;
